import React from 'react';

const IFCondition = ({children, cond}) => {
  return !cond ? null : <>{children}</>
}

export default IFCondition